<template>
     <div class="container">
         <div class="row">
             <div class="col-md-12 col-sm-12 col-xs-12" id="area-operatore">
                 <div class="row">
                     <div class="col-md-4 col-xs-12" id="lista-chat">
                        <div class="row">
                             <div class="col-6">
                                <ficon :icon="['fas', 'user']" size="2x"></ficon> <span>Ciao {{userData.name}}</span>
                             </div>
                             <div class="col-6 d-flex align-items-center justify-content-end">
                                <ficon :icon="['fas', 'circle']" class="circle-connect" v-if ="userData.status == 1"></ficon>

                                    <b-nav-item-dropdown no-caret class="m-2 unstyled">
                                        <template slot="button-content">
                                            <ficon :icon="['fas', 'ellipsis-v']" class="color-icon"></ficon>
                                        </template>
                                        <b-dropdown-item @click="listaOperatori">Operatori Attivi</b-dropdown-item>
                                        <b-dropdown-item @click="logout">Logout</b-dropdown-item>
                                    </b-nav-item-dropdown>
                                                                
                             </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-12 d-flex align-items-center justify-content-end">
                                <input type="text" class="form-control" v-model="searchTxt" placeholder="Cerca" @change="search" name="saerch">
                                <button class="btn tbn-default btn-search" href="javascript:void()" @click="search">
                                    <ficon :icon="['fas', 'search']"></ficon>
                                </button> 
                            </div>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3" fill>
                                <b-tab ref="tab_attive" active @click="changeTab('attive')">
                                    <template slot="title">
                                        Attive
                                        <b-badge pill v-if="this.count_all_notifiche > 0">{{ this.count_all_notifiche }}</b-badge>
                                    </template>
                                    <div id="chat-attive">
                                        <div class="row">
                                            <div class="col-12 d-flex justify-content-start">
                                                <h5 class="title">Attive</h5>
                                            </div>
                                            <div class="col-12 d-flex justify-content-start" v-if =" this.chat_user_assigned == null">
                                                <h6>Nessuna chat presente</h6>
                                            </div>

                                            <div class="col-12 d-flex justify-content-start" v-if =" this.chat_user_assigned != null && this.chat_user_assigned.length == 0">
                                                <h6>Nessuna chat presente</h6>
                                            </div>
                                            
                                            <div class="col-12" v-if ="this.chat_user_assigned != null && this.chat_user_assigned.length > 0">
                                                <div class="row">
                                                    <div class="col-lg-12 col-md-12 col-sm-12 align-items-center" v-for="(value , key) in this.chat_user_assigned" v-bind:key="key">
                                                        <card-assigned :element="value" :callbackRilascia="callbackRilascia" :callbackChiudi="callbackChiudi" :showChat="showChat"></card-assigned> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 d-flex justify-content-start">
                                                <h5 class="title">Da assegnare</h5>
                                            </div>
                                            <div class="col-12 d-flex justify-content-start" v-if =" this.chat_not_assigned == null">
                                                <h6>Nessuna chat presente</h6>
                                            </div>

                                            <div class="col-12 d-flex justify-content-start" v-if =" this.chat_not_assigned != null && this.chat_not_assigned.length == 0">
                                                <h6>Nessuna chat presente</h6>
                                            </div>
                                            
                                            <div class="col-12" v-if ="this.chat_not_assigned != null && this.chat_not_assigned.length > 0">
                                                <div class="row">
                                                    
                                                    <div class="col-lg-12 col-md-12 col-sm-12 align-items-center" v-for="(value , key) in this.chat_not_assigned" v-bind:key="key">
                                                        <card-not-assigned :element="value" :callbackInCarico="callbackInCarico" :showChat="showChat"></card-not-assigned> 
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                        <div class="row">
                                            <div class="col-12 d-flex justify-content-start">
                                                <h5 class="title">Assegnate altri operatori</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 d-flex justify-content-start" v-if =" this.chat_other_assigned == null">
                                                <h6>Nessuna chat presente</h6>
                                            </div>
                                            <div class="col-12 d-flex justify-content-start" v-if =" this.chat_other_assigned != null && this.chat_other_assigned.length == 0">
                                                <h6>Nessuna chat presente</h6>
                                            </div>
                                            <div class="col-12" v-if ="this.chat_other_assigned != null &&  this.chat_other_assigned.length > 0">
                                                <div class="row">
                                                    <div class="col-lg-12 col-md-12 col-sm-12 align-items-center" v-for="(value , key) in this.chat_other_assigned" v-bind:key="key">
                                                        <card-other-assigned :element="value" :showChat="showChat"></card-other-assigned> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Archiviate" ref="tab_chiuse" @click="changeTab('chiuse')">
                                    <div class="row form-group">
                                        
                                        <div class="col-12">
                                            <input type="date" class="w-100" ref="date-archived" v-model="data_search" id="date-archived" v-on:change="onRefershArchived">
                                        </div>

                                    </div>
                                    <hr>
                                    <div class="col-12" v-if="this.chat_archived == null">
                                        <p>Nessuna Chat Archivata</p>
                                    </div>
                                    <div class="col-12" v-if =" this.chat_archived != null && this.chat_archived.length == 0">
                                            <h5>Nessuna chat Archivata</h5>
                                        </div>
                                    <div class="col-12" v-if="this.chat_archived != null && this.chat_archived.length > 0">
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12 align-items-center" v-for="(value , key) in this.chat_archived" v-bind:key="key">
                                                <card-archived :element="value" :showChat="showChat"></card-archived> 
                                            </div>
                                        </div>
                                        
                                    </div>
                                </b-tab>
                                
                            </b-tabs>
                        </div>

                     </div>
                     <div class="col-md-8 col-xs-12" id="body-chat">
                        <audio id="mySound" ref="notifica" src=""></audio>
                        <body-chat  :element="this.chat_selected" 
                                    :list_message="this.chat_list_message" 
                                    :typeChat="this.type_chat"
                                    :typingMessage="this.typingMessage"
                                    :client="this.client"
                                    :showChat="showChat"
                                    :countChat="count_chat"
                                    :countAllChat="count_all_chat"
                                    :list_suggerimenti="this.list_suggerimenti"
                                    :showSuggerimenti="false"
                                    :callbackInCarico="callbackInCarico" 
                                    :callbackRilascia="callbackRilascia" 
                                    :callbackChiudi="callbackChiudi"
                                    :endChat="this.endChat"
                                     >
                        </body-chat>
                     </div>
                 </div>
             </div>
             <div class="col-1"></div>
        </div>
        <b-modal id="modal-sm" ref="modal-operatori" size="lg" title="Lista operatori attivi">
            <div class="row pb-2">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <th>Operatore</th>
                                <th>Data Login</th>
                                <th>Ultimo Messaggio</th>
                                <th>In Carico</th>
                                <th><ficon :icon="['fa', 'bolt']" class="ml-1 color-icon icon-pointer"></ficon></th>
                            </thead>
                            <tbody v-for="(value , key) in this.arrayOperatori" v-bind:key="key">
                                <operatori-item :operatore=value :operatorerId="userData.userId" :callbackHideModal="callbackHideModal" :callbackModalError="callbackModalError" :callbackModalRemoveError="callbackModalRemoveError"></operatori-item>
                            </tbody>
                        </table>
                    </div>
                    <div class="row" v-if="this.errorMessageModal">
                        <div class="col-12 text-center">
                            <p><strong>Non sei abilitato ad eseguire questa operazione!</strong></p>
                        </div>
                    </div>
                </div>
            </div>
            
        </b-modal>
        <b-modal id="modal-sm" ref="modal-audio" name="modal-audio" size="lg" title="Audio non attivo">
            <div class="row pb-2">
                <div class="col-12">
                    <div class="row form-group">
                        <div class="col-12">
                            <h5 class="text-center">
                                L'audio nel browser non è abilitato! Clicca "Attiva" per abilitarlo!
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6"></div>
                        <div class="col-6 d-flex justify-content-end">
                            <b-button class="mr-3" variant="outline-danger"  @click="hideModalAudio">Chiudi</b-button>
                            <b-button variant="outline-success"  @click="AttivaAudio()">Attiva</b-button>
                        </div>
                    </div>
                </div>
            </div>
            
        </b-modal>
     </div>
</template>

<script>
    import BackendApi from '../models/BackendApi'
    import ClientChat from '../models/ClientChat'
    import CardNotAssigned from '@/components/CardNotAssigned.vue'
    import CardAssigned from '@/components/CardAssigned.vue'
    import CardOtherAssigned from '@/components/CardOtherAssigned.vue'
    import CardArchived from '@/components/CardArchived.vue'
    import BodyChat from '@/components/BodyChat.vue'
    import OperatoriItem from '@/components/OperatoriItem.vue'
    import CounterNotify from '../models/CounterNotify.js'
    import defapp from '../models/defapp.js'
    import MessageChat from '../models/MessageChat'

    const someSound = require("../assets/notifica2.mp3");
    const someSoundTest = require("../assets/no_sound.mp3");

    export default {
        name: 'AreaOperatore',
        data: function() {
            return {
                searchTxt: "",
                tabactive: "attive",
                userData: JSON.parse(localStorage.getItem('userLogged')),
                chat_user_assigned: [],
                chat_other_assigned: [],
                chat_not_assigned: [],
                chat_archived: [],
                chat_selected: null,
                chat_list_message: [],
                type_chat: 0,
                count_chat: 0,
                count_all_chat: 0,
                client: null,
                audio: null,
                testAudio: null,
                count_all_notifiche: 0,
                count_not_assigned_notiche:0,
                typingMessage : false,
                list_suggerimenti: [],
                showSuggerimenti: false,
                arrayOperatori: [],
                errorMessageModal: false,
                endChat: false,
                notifySound: someSound,
                notifySoundTest: someSoundTest,
                flagAudio:true,
                data_search: "",
            };
        },
        components: {    
            CardNotAssigned,CardAssigned,CardOtherAssigned,CardArchived,BodyChat,OperatoriItem
        },
        computed: {       
        },
        methods: {    
            changeTab(stato)
            {
                this.tabactive = stato;
                this.chat_selected = null;
                return true;
            },
            search()
            {
                
                let api = new BackendApi(this.configApp)
                api.search(this.tabactive,this.searchTxt,this.userData.userId,"", (result) => {
                    if(result["success"] != false)
                    {
                        this.chat_user_assigned = result.chat_user_assigned
                        this.chat_other_assigned = result.chat_other_assigned
                        this.chat_not_assigned = result.chat_not_assigned
                        this.chat_archived = result.chat_archived

                    }
                
                });
                
            },
            onRefershArchived()
            {
                let api = new BackendApi(this.configApp)
                api.search(this.tabactive,this.searchTxt,this.userData.userId,this.data_search, (result) => {
                    if(result["success"] != false)
                    {
                        this.chat_archived = result.chat_archived

                    }
                
                });
            },
            changeStatus()
            {
            let api = new BackendApi(this.configApp)
                api.changeStatus(this.userData.userId, (result) => {
                    this.userData = result;
                    localStorage.setItem("userLogged", JSON.stringify(result));
                
                });
            },
            listaOperatori()
            {
                let api = new BackendApi(this.configApp)
                api.listaOperatori((result) => {
                    console.log(result)
                    if(result.success)
                    {
                        this.arrayOperatori = result.lista.data;
                        console.log(this.arrayOperatori);
                        this.$refs['modal-operatori'].show()
                    }
                })
            },
            callbackInCarico(element,refresh = 0,type_chat = 0)
            {
               
                let api = new BackendApi(this.configApp)
                this.chat_selected = element
                let counterNotify = new CounterNotify()
                this.endChat = false
                api.prendiInCarico(element.id,this.userData.userId, (result) => {
                    
                    if(result["success"] != false)
                    {
                        this.chat_user_assigned = result.chat_user_assigned
                        this.chat_other_assigned = result.chat_other_assigned
                        this.chat_not_assigned = result.chat_not_assigned
                        this.chat_archived = result.chat_archived
                        //INVIARE UNA NOTIFICA DI PRESA IN CARICO
                        
                        this.count_not_assigned_notiche = 0;
                        counterNotify.sendPresainCaricoNotify(this.client,this.chat_selected,this.userData.name,this.userData.userId)
                        
                        if(refresh != 0)
                        {
                            this.chat_selected.staff_id = this.userData.userId
                            
                            this.showChat(this.chat_selected,type_chat)
                        } 
                        
                    }
                
                });
            },
            callbackRilascia(chat_id,refresh = 0,type_chat = 0)
            {
                let api = new BackendApi(this.configApp)
                let counterNotify = new CounterNotify()
                this.endChat = true
                api.rilasciaChat(chat_id,this.userData.userId, (result) => {
                    if(result.success != false)
                    {
                        this.chat_user_assigned = result.chat_user_assigned
                        this.chat_other_assigned = result.chat_other_assigned
                        this.chat_not_assigned = result.chat_not_assigned
                        this.chat_archived = result.chat_archived
                        this.count_not_assigned_notiche = 0;
                        
                        counterNotify.sendRilasciaNotify(this.client,this.chat_selected,this.userData.name,this.userData.userId)
                       
                        if(refresh != 0)
                        {
                            this.showChat(this.chat_selected,type_chat)
                        }
                        this.chat_selected = null;
                    }
                
                
                });
            },
            callbackChiudi(chat_id,refresh = 0,type_chat = 0)
            {
                let api = new BackendApi(this.configApp)
                let counterNotify = new CounterNotify()
                api.chiudiChat(chat_id,this.userData.userId, (result) => {
                    if(result["success"] != false)
                    {
                        this.chat_user_assigned = result.chat_user_assigned
                        this.chat_other_assigned = result.chat_other_assigned
                        this.chat_not_assigned = result.chat_not_assigned
                        this.chat_archived = result.chat_archived
                       
                        if(refresh != 0)
                        {
                            this.showChat(this.chat_selected,type_chat)
                        }
                        counterNotify.sendNotifyChiusura(this.client,this.chat_selected)
                        this.count_not_assigned_notiche = 0;
                        this.chat_selected = null
                        this.endChat = false
                    }
                
                });
               
            },
            logout()
            {
                let api = new BackendApi(this.configApp)
                api.logout(this.userData.userId,"", (result) => {
                    this.count_not_assigned_notiche = 0;
                    if(result["success"] == true)
                    {
                        localStorage.setItem('userLogged' , null);
                        this.$router.push('Login') 
                    }
                
                });
                
            },
            showChat(element,type_chat,limit = defapp.LIMIT_MESSAGE, archived = false)
            {
                this.chat_selected = element
                let api = new BackendApi(this.configApp)
                let counterNotify = new CounterNotify()
                api.listMessage(element.id,element.staff_id, limit, (result) => {
                    if(result["success"] != false)
                    {
                        this.chat_list_message = result.chat_list_message
                        this.count_chat = parseInt(result.count)
                        this.count_all_chat = parseInt(result.count_all)
                        this.type_chat = type_chat
                        this.list_suggerimenti = result.suggerimenti
                        this.showSuggerimenti = false
                        
                        if(archived == false)
                        {
                            if(element.counter_notify > 0)
                            {
                                counterNotify.sendNotifyRead(this.client,element,this.chat_list_message,this.userData.userId)
                            }
                        }

                        if(archived == true)
                        {
                            this.count_not_assigned_notiche = 0;
                        }

                        this.count_not_assigned_notiche = 0;
                        

                        //this.updateAllNotify()
                    }
                    this.scrollToEnd()
                
                });
            },
            onClientCallbackOnConnect: function(isConnect) {
                console.log("onClientCallbackOnConnect -> ",isConnect)
            },
            playNotify()
            {
                console.log("playNotify")

                this.audio.load();
                let promise = this.audio.play();

                if (promise !== undefined) {
                    promise.then(() => {
                        console.log("PROMISE SUCCESS");
                    }).catch((error) => {
                        // Autoplay was prevented.
                        // Show a "Play" button so that user can start playback.
                        this.$refs['modal-audio'].show();
                        console.log("ERROR PROMISE AUDIO");
                        console.log(error);
                    });
                }
            },
            hideModalAudio()
            {
                this.$refs['modal-audio'].hide();
            },
            AttivaAudio()
            {
                this.audio.load();
                this.audio.play();
                this.testAudio.load();
                this.testAudio.play();
                document.title = "LiveChat"
                this.flagAudio = true
                this.$refs['modal-audio'].hide();
            },
            onClientCallbackReceiveMessage: function(message) {
                console.log("onClientCallbackReceiveMessage -> ",message.body)

                let counterNotify = new CounterNotify()
                let result = JSON.parse(message.body)

                if(this.chat_selected == null)
                {
                    if(result.staff_id == null && result.type != MessageChat.TYPE_END_MESSAGE && result.type != MessageChat.TYPE_READ_MESSAGE)
                    {

                        this.playNotify();
                    }
                    
                    if(result.type != MessageChat.TYPE_END_MESSAGE && result.type != MessageChat.TYPE_READ_MESSAGE && result.type != MessageChat.TYPE_RILASCIA_MESSAGE)
                    {
                        this.count_not_assigned_notiche ++;
                    } else {

                        this.count_not_assigned_notiche = 0;
                    }

                    this.refreshChatList()
                    
                } else {
                    
                    switch(result.type)
                    {
                        case MessageChat.TYPE_READ_MESSAGE:
                            counterNotify.updateCounter(result,this.chat_list_message,this.chat_selected,this.chat_user_assigned)
                            break
                        case MessageChat.TYPE_INCARICO_MESSAGE:
                            if(result.staff_id == this.userData.userId)
                            {
                                this.chat_list_message.push(result)
                                this.chat_selected.last_message = result.date_orig
                                
                            } else {
                                this.refreshChatList()
                            }
                            break
                        case MessageChat.TYPE_RILASCIA_MESSAGE:
                            this.count_not_assigned_notiche = 0;
                            if(this.userData.userId == result.staff_id)
                            {
                                this.$router.push('Login')
                            }
                            this.refreshChatList()
                            break
                        case MessageChat.TYPE_END_MESSAGE:
                            var control = counterNotify.controlMessageChat(result,this.chat_selected,this.chat_user_assigned,this.chat_other_assigned)
                            if (control == CounterNotify.TYPE_RESULT_PRESENT)
                            {
                                this.chat_list_message.push(result)
                                this.type_chat = defapp.TYPE_CHAT_ARCHIVED;
                                this.chat_selected.last_message = result.date_orig
                            } 
                            this.refreshChatList()
                            break
                        case MessageChat.TYPE_TYPING_MESSAGE:
                            if(result.staff_id == this.userData.userId)
                            {
                                this.typingMessage = true;
                                setTimeout(() => this.typingMessage = false,4000)
                            }
                            break;
                        default:

                            
                            if(result.type_user == defapp.TYPE_MESSAGE_RECEIVED)
                            {
                                //NOTIFICA READ SINGOLO MESSAGGIO
                                //CONTROLLO SE IL MESSAGGIO ARRIVATO FAPARTE DELLA CHAT SELECTED SE E COSI INVIO NOTIFICA READ
                                let result_control = counterNotify.controlMessageChat(result,this.chat_selected,this.chat_user_assigned,this.chat_other_assigned)
                                 
                                if (result_control == CounterNotify.TYPE_RESULT_PRESENT)
                                {
                                    this.chat_list_message.push(result)
                                    this.chat_selected.last_message = result.date_orig
                                    counterNotify.sendSingleNotifyRead(this.client,result,this.userData.userId)
                                } else {
                                    //SE RESTITUISCE 1 SIGNIFICA CHE IL MESSAGGIO ARRIVATO NON FA PARTE DI UNA CHAT PRESENTE QUINDI FACCIO IL REFRESH DELA LISTA
                                    if(result_control == CounterNotify.TYPE_RESULT_NOT_PRESENT)
                                    {
                                        if(result.staff_id == null)
                                        {
                                            this.playNotify();
                                        }
                                        this.count_not_assigned_notiche ++;
                                        this.refreshChatList()
                                    }
                                    
                                }
                            } else {
                                if(result.type_user == defapp.TYPE_MESSAGE_AUTOMATIC && result.from == 'Kiri')
                                {
                                    let result_control = counterNotify.controlMessageChat(result,this.chat_selected,this.chat_user_assigned,this.chat_other_assigned)
                                 
                                    if (result_control == CounterNotify.TYPE_RESULT_PRESENT)
                                    {
                                        this.chat_list_message.push(result)
                                        this.chat_selected.last_message = result.date_orig
                                        counterNotify.sendSingleNotifyRead(this.client,result,this.userData.userId)
                                    } else {
                                        //SE RESTITUISCE 1 SIGNIFICA CHE IL MESSAGGIO ARRIVATO NON FA PARTE DI UNA CHAT PRESENTE QUINDI FACCIO IL REFRESH DELA LISTA
                                        if(result_control == CounterNotify.TYPE_RESULT_NOT_PRESENT)
                                        {
                                            if(result.staff_id == null)
                                            {
                                                this.playNotify();
                                            }
                                            this.count_not_assigned_notiche ++;
                                            this.refreshChatList()
                                        }
                                        
                                    }
                                }
                                else
                                {
                                    this.chat_list_message.push(result)
                                    this.chat_selected.last_message = result.date_orig
                                }

                               
                               
                            }
                            this.typingMessage = false
                            
                            break
                    }
                   
                    this.scrollToEnd()
                }
                //this.updateAllNotify()
            },
            scrollToEnd : function()
            {
                let elmnt = document.getElementById('body-message-chat');
                let valueScroll = (elmnt.offsetTop + (this.count_chat * elmnt.offsetHeight) + elmnt.offsetHeight)
                setTimeout(() => document.getElementById('body-message-chat').scrollTop = valueScroll,100)
                 
            },
            refreshChatList()
            {
               
                let api = new BackendApi(this.configApp)
                api.operatoreChatList(this.userData.userId, (result) => {
                    this.chat_user_assigned = result.chat_user_assigned
                    this.chat_other_assigned = result.chat_other_assigned
                    this.chat_not_assigned = result.chat_not_assigned
                    this.chat_archived = result.chat_archived
                
                    //this.updateAllNotify()
                });
            },
            updateAllNotify()
            {
                let counterNotify = new CounterNotify()
                this.count_all_notifiche = counterNotify.countNotificheNonLette(this.chat_user_assigned)
                //this.count_not_assigned_notiche = counterNotify.countNotificheNonLette(this.chat_not_assigned)
               
                if(this.count_all_notifiche > 0)
                {
                    let i = 0
                    setInterval(() => {
                        if(this.count_all_notifiche > 0)
                        {
                            
                                if(i == 0)
                                {
                                    document.title = "Hai " + this.count_all_notifiche + " messaggi da leggere";
                                    i = 1;
                                } else {
                                    if(this.flagAudio == true)
                                        document.title = "LiveChat"
                                    else 
                                        document.title = "AUDIO NON ATTIVO"
                                    i = 0;
                                }
                            
                        }
                    },500);  
                
                } else {
                    if(this.count_not_assigned_notiche > 0)
                    {
                        let k = 0;
                        
                        setInterval(() => {
                            if(this.count_not_assigned_notiche > 0)
                            {
                                
                                if(k == 0)
                                {
                                    document.title = "Nuovo messaggio da leggere";
                                    k = 1;
                                } else {
                                    if(this.flagAudio == true)
                                        document.title = "LiveChat"
                                    else 
                                        document.title = "AUDIO NON ATTIVO"
                                    k = 0;
                                }
                                
                            } else {
                                if(this.flagAudio == true)
                                    document.title = "LiveChat"
                                else 
                                    document.title = "AUDIO NON ATTIVO"
                                k = 0;
                            }
                        },500);
                        
                    } else {
                        if(this.flagAudio == true)
                            document.title = "LiveChat"
                        else 
                            document.title = "AUDIO NON ATTIVO"
                    }
                }
                
            },
            generaLead()
            {
                alert("LEAD");
            },
            callbackHideModal()
            {
                this.$refs['modal-operatori'].hide()
                this.errorMessageModal = false
            },
            callbackModalError()
            {
                this.errorMessageModal = true
            },
            callbackModalRemoveError()
            {
                this.errorMessageModal = false
            },
            aliveOperator(userId)
            {
                let api = new BackendApi(this.configApp)
                setInterval(function(){
                    api.aliveOperator(userId)
                },60000);
            },
            controlAudio()
            {
                console.log("controlAudio " + this.flagAudio );
               
                var promiseTest = this.testAudio.play();
                if (promiseTest !== undefined) {
                    promiseTest.then(() => {
                        console.log("PROMISE TEST SUCCESS");
                        this.flagAudio = true
                    }).catch((error) => {
                        // Autoplay was prevented.
                        // Show a "Play" button so that user can start playback.
                        document.title = "AUDIO NON ATTIVO"
                        this.flagAudio = false
                        this.$refs['modal-audio'].show();
                        console.log("ERROR PROMISE TEST AUDIO");
                        console.log(error);
                    });
                }
            },
            onClientCallbackDisconnect()
            {
                
                setTimeout(() => {
                    this.client.open(this.userData.queue,this.userData.username,this.userData.tokenAccess,this.onClientCallbackOnConnect,this.onClientCallbackReceiveMessage, this.onClientCallbackDisconnect)

                },1000);
            }
        },
        created: function() { 
            document.title = "LiveChat"
            let api = new BackendApi(this.configApp)
            if(this.userData == null)
            {
                this.$router.push('Login') 
            } else {
                //CHECK VALIDAZIONE CREDENZIALI
                api.verificaAuth(this.userData.tokenAccess,this.userData.userId, (result) => {
                    if(result.success == false)
                    {
                        localStorage.removeItem('userLogged')
                        this.$router.push('Login') 
                    }
                })
            }
            api.operatoreChatList(this.userData.userId, (result) => {
                this.chat_user_assigned = result.chat_user_assigned
                this.chat_other_assigned = result.chat_other_assigned
                this.chat_not_assigned = result.chat_not_assigned
                this.chat_archived = result.chat_archived
               
            });
            this.client = new ClientChat(this.configApp)
            this.client.open(this.userData.queue,this.userData.username,this.userData.tokenAccess,this.onClientCallbackOnConnect,this.onClientCallbackReceiveMessage, this.onClientCallbackDisconnect)
            this.aliveOperator(this.userData.userId);
            
            this.audio = new Audio(this.notifySound);
            this.testAudio = new Audio(this.notifySoundTest);

            let d = new Date();
            let month = (d.getMonth() +1).toString();
            let day = d.getDate().toString();
            
            if(month.length == 1)
            {
                month = "0"+month;
            }
             if(day.length == 1)
            {
                day = "0"+day;
            }
            this.data_search = d.getFullYear() + "-" + month + "-" + day;
            
           
            setInterval(() => {
                this.controlAudio()
            } , 10000);

            setInterval(() => {
                this.updateAllNotify();
            } , 5000);

        },
        mounted:function(){
            
            
        },
    }
</script>